<footer class="footer">
  platzi master
</footer>
